import React, {useCallback, useRef} from 'react';
import T from "i18n-react";
import Moment from "react-moment";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {documentService} from "../../../services/document-service";
import {Button, Card} from "react-bootstrap-v5";
import RemoteTable from "../../../components/table/remote-table";
import {ping} from "../../../services/api/api";
import {useHistory} from "react-router-dom";
import {Routes} from "../../../router/router-constants";
import {connect} from "react-redux";
import {UserRole} from "../../../utils/enums/user-role";
import {SortDirection} from "../../../utils/enums/sort-direction";
import DateInput from "../../../components/input-label/date-input";
import {alertActions} from "../../../redux/alert/actions-alert";
import {ToastClass} from "../../../components/toast-alert/toast-alert-class";
import {documentActions} from "../../../redux/document/actions-document";
import {confirmDialogActions} from "../../../redux/confirm-dialog/actions-confirm-dialog";

const TableAllDocuments = ({
                               searchText,
                               className,
                               currentUser,
                               showEditDocumentModal,
                               showConfirmDialog,
                               documentDeleted,
                               showToast,
                               progress,
                               incrementProgress
                           }) => {

    let columns = [
        {
            dataField: T.translate('table.fields.product.articleCode').toString(),
            text: T.translate('table.columns.product.articleCode').toString(),
            sort: true
        },
        {
            dataField: T.translate('table.fields.productName').toString(),
            text: T.translate('table.columns.lot.productName').toString(),
            sort: true
        },
        {
            dataField: T.translate('table.fields.lot.lotNumber').toString(),
            text: T.translate('table.columns.lot.lotNumber').toString(),
            sort: true
        },
        {
            dataField: T.translate('table.fields.description').toString(),
            text: T.translate('table.columns.description').toString(),
            sort: true
        },
        {
            dataField: T.translate('table.fields.name').toString(),
            text: T.translate('table.columns.document.name').toString(),
            sort: true
        },
        {
            dataField: T.translate('table.fields.document.originalFileName').toString(),
            text: T.translate('table.columns.fileName').toString(),
            sort: true
        },
        {
            dataField: T.translate('table.fields.createdDate').toString(),
            text: T.translate('table.columns.createdDate').toString(),
            sort: true
        },
        {
            dataField: T.translate('table.fields.document.validityDate').toString(),
            text: T.translate('table.columns.document.validityDate').toString(),
            sort: true
        },
        {
            dataField: T.translate('table.fields.document.deadline').toString(),
            text: T.translate('table.columns.deadline').toString(),
            sort: true
        },
        {
            dataField: T.translate('table.fields.actions').toString(),
            text: T.translate('table.columns.actions').toString(),
            sort: false
        },
    ];

    const history = useHistory();

    const downloadDocRef = useRef();

    const downloadDocument = async (fileUri) => {
        downloadDocRef.current.href = fileUri;
        // ici on ping pour éventuellement forcer axios à appeler le refresh token et éviter sinon que le download envoie un 401 car c'est un appel backend direct
        await ping();
        downloadDocRef.current.click();
    }

    const onFetchData = useCallback(async (page, size, sortedOrder, sortedField, searchText) => {
        const handleNavigateToProduct = productId => {
            if (currentUser.role === UserRole.READER) return;
            history.push(`${Routes.PRODUCTS_PAGE}/${productId}`);
        }

        const handleNavigateToLot = lotId => {
            if (currentUser.role === UserRole.READER) return;
            history.push(`${Routes.LOTS_PAGE}/${lotId}`);
        }

        const handleEditDocument = (e, doc) => {
            showEditDocumentModal(doc)
        }

        const handleValidityDateChange = async (documentId, date, documentName) => {
            const validityDate = date ?? '';

            try {
                await documentService.editValidityDate(documentId, validityDate);
                incrementProgress();

                showToast(T.translate('alert.successTitle'), T.translate('document.successEditValidityDate', {documentName}), ToastClass.SUCCESS)
            } catch (error) {
                showToast(T.translate('alert.errorTitle'), error.message, ToastClass.ERROR);

            }
        }

        const deleteDocument = async doc => {
            try {
                await documentService.deleteDocument(doc.documentId);
                documentDeleted();

                showToast(T.translate('alert.successTitle'), T.translate('document.successDeleteDocument', {documentName: doc.name}), ToastClass.SUCCESS);
            } catch (error) {
                showToast(T.translate('alert.errorTitle'), error.message, ToastClass.ERROR);
            }
        }

        const handleDeleteDocument = async (e, doc) => {
            e.stopPropagation();
            showConfirmDialog(
                T.translate('dialog.title.confirmDelete'),
                T.translate('dialog.confirmDeleteDocument', {documentName: doc.name}),
                () => {
                },
                () => deleteDocument(doc))
        }

        const completeElements = allElements => {
            return allElements.map(element => {
                const dayDealine = element.daysBeforeEndValidityDate < 0 ? `+${-element.daysBeforeEndValidityDate}` : -element.daysBeforeEndValidityDate;
                const hasDateExpired = (!!element.daysBeforeEndValidityDate || element.daysBeforeEndValidityDate === 0) && element.daysBeforeEndValidityDate <= 0;
                const canEditValidityDate = currentUser.role !== UserRole.READER && currentUser.role !== UserRole.VISITOR;
                return {
                    ...element,
                    id: element.documentId,
                    description: element.description ?? "-",
                    articleCode: !element.articleCode ? "-" : (
                        <div className={currentUser.role !== UserRole.READER && "cursor-pointer"}
                             onClick={() => handleNavigateToProduct(element.productId)}>{element.articleCode}</div>
                    ),
                    productName: !element.productName ? "-" : (
                        <div className={currentUser.role !== UserRole.READER && "cursor-pointer"}
                             onClick={() => handleNavigateToProduct(element.productId)}>{element.productName}</div>
                    ),
                    lotNumber: !element.lotNumber ? "-" : (
                        <div className={currentUser.role !== UserRole.READER && "cursor-pointer"}
                             onClick={() => handleNavigateToLot(element.lotId)}>{element.lotNumber}</div>
                    ),
                    createdDate: <Moment>{element.createdDate}</Moment>,
                    validityDate:
                        <React.Fragment>
                            {!canEditValidityDate && !!element.validityDate && <Moment>{element.validityDate}</Moment>}
                            {canEditValidityDate && <DateInput className="editable-date" id="validityDate" defaultValue={element.validityDate}
                                                               onChange={date => handleValidityDateChange(element.documentId, date, element.name)}
                                                               adjustWidthWithText={true} adjustWidthForEmptyText={true}
                                                               isTextInRed={hasDateExpired}/>}
                        </React.Fragment>,
                    daysBeforeEndValidityDate: !element.validityDate ? "-" :
                        <span className={`${hasDateExpired ? "color-danger" : ""}`}>{T.translate('table.columns.dayDeadline', {dayNumber: dayDealine})}</span>,
                    actions: (
                        <div className="actions">
                            <div className="btn btn-primary btn-sm me-1"
                                 onClick={() => downloadDocument(documentService.getDownloadUrl(element.fileDownloadUri))}>
                                <FontAwesomeIcon icon="download"/>
                            </div>
                            {currentUser.role !== UserRole.READER && currentUser.role !== UserRole.VISITOR &&
                                <Button size="sm" className="edit me-1" onClick={e => handleEditDocument(e, element)}>
                                    <FontAwesomeIcon icon="edit"/>
                                </Button>}
                            {currentUser.role !== UserRole.READER && currentUser.role !== UserRole.VISITOR && currentUser.role !== UserRole.CONTRIBUTOR && element.template !== "LOT_PURCHASE_ORDER" &&
                                <Button size="sm" className="delete"
                                        onClick={e => handleDeleteDocument(e, element)}>
                                    <FontAwesomeIcon icon="times"/>
                                </Button>}
                        </div>
                    )
                }
            });
        }

        const data = await documentService.getAll(page, size, sortedOrder, sortedField, searchText);
        const elements = completeElements(data.content);
        return {
            ...data,
            elements: elements
        };
    }, [history, currentUser.role]);

    return (
        <Card className={className}>
            <RemoteTable id="table-document-list" isOverflowYHidden={false} tableMinHeight={'400px'}
                         defaultSortedField={T.translate('table.fields.createdDate')}
                         defaultSortedOrder={SortDirection.DESC}
                         columns={columns} onFetchData={onFetchData} searchText={searchText} reload={progress}/>
            <a ref={downloadDocRef} href="#0" hidden={true} download>download</a>
        </Card>
    );
}

const mapStateToProps = state => {
    return {
        currentUser: state.authReducer.currentUser,
        progress: state.documentReducer.progress,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        showToast: (title, message, className) => dispatch(alertActions.addToast(title, message, className)),
        showConfirmDialog: (title, body, onCancel, onConfirm) => dispatch(confirmDialogActions.showConfirmDialog(title, body, onCancel, onConfirm)),
        showEditDocumentModal: (doc) => dispatch(documentActions.documentEdit(doc)),
        documentDeleted: () => dispatch(documentActions.documentDeleted()),
        incrementProgress: () => dispatch(documentActions.incrementProgress())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TableAllDocuments);
